export default __webpack_public_path__ + "static/media/mentoriaOne.6f56c674.png";